import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { AuBodyTextModule } from '../au-body-text/au-body-text.module';
import { FileTypes } from '@shared/ui-components/au-document-type/file-types';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-document-type',
	imports: [MatIconModule, AuBodyTextModule, NgxTolgeeModule],
	templateUrl: './au-document-type.component.html',
	styleUrls: ['./au-document-type.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuDocumentTypeComponent {
	@Input() set type(type: string) {
		this.selectedType = this.fileTypes[type];
	}
	@Input() smallFont = false;

	readonly fileTypes = FileTypes;

	selectedType;
}
